
import { useState, useEffect} from "react";

import Config from "../Config";

import input_check from "../input_check.png";
import input_error from "../input_error.png";


 

function InputComboDzien(props)
{

    

    const [gr, setGr] = useState(null);
    
    const [miesiac, setMiesiac] = useState(props.miesiac);
    const [rok, setRok] = useState(props.rok);
    
    
    const [val, setVal] = useState(props.value);
    const [req, setRequired] = useState(props.req);
    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );



 
    
    const getDaysInMonth = (y,m) =>  {


        var numM = parseInt(m);
        var numY = parseInt(y);

        var day = 0;

        if(numM == 1) {  day = 31; } else 
        if(numM == 2) {  day = 29; } else //!!
        if(numM == 3) {  day = 31; } else  
        if(numM == 4) {  day = 30; } else  
        if(numM == 5) {  day = 31; } else 
        if(numM == 6) {  day = 30; } else 
        if(numM == 7) {  day = 31; } else 
        if(numM == 8) {  day = 31; } else 
        if(numM == 9) {  day = 30; } else 
        if(numM == 10) { day = 31; } else 
        if(numM == 11) { day = 30; } else 
        if(numM == 12) { day = 31; } 

        if( numM == 2)
        {
            if(  numY % 4 == 0 ) 
            {
                if( numY % 100 == 0 || numY % 400 == 0)
                {
                    day = 29;
                }
            }
        }

        return day;
    }   

    const getGr = () => {
       
 
        var y = new Array();

        if(!(props.noempty != null && props.noempty != undefined &&  props.noempty=='1'))
            {
                y.push({
                    v: '_x_',
                    title: '- - -'
                });
            }

        var last = getDaysInMonth(rok,miesiac);

        console.log("Last",rok,miesiac, last);


        for(var k = 1; k<=last; k++)    
        {


            var dd = k+"";
            if( dd.length == 1) dd = "0" + dd;

            y.push({
                v: dd,
                title: dd
            });
        }
 

        

 

        setGr(y);      
 
    }

   

    const checkAndChange = (e) =>
    {
        var v = e.target.value;

 


        setVal(v);

        var correct = true;

        if(req == '1' &&  v=='_x_' ) correct = false;         

        if(v == '_y_del')
        {
            setView({
                v: 'new',
                id: -1
            });
            return;
        }
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'combo');
        }else
        {
            console.log('No support for valChange');
        }    
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' && val != undefined && val == '_x_') correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }


    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }



    useEffect(() => {


   

        if(val != props.value && props.value != undefined) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct,'');
    
        }
    })



    const onBack = (id) => {                 
        
        setVal(id);
        setGr(null);
       
  
        
        setView({
            v: 'list',
            id: -1
        });
    }


    var dlg = null;
    
   
    
    if( gr == null ||  gr.length == 0 )
    {
        getGr();
        
        return <fieldset>
                            
           </fieldset>                     
        
    }


    

    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }


    if(miesiac != props.miesiac)
        {
            setMiesiac(props.miesiac);
            setGr(null);
            return <div>...</div>
        }
        
    
        if(rok != props.rok)
            {
                setRok(props.rok);
                setGr(null);
                return <div>...</div>
            }



    var cnX = cn;
    if(val.length < 1 && cnX == 'corrent')
        {
            cnX = '';
        }


    if( (val+"").length == 1)
        {
            var x = val;
            x = "0"+x;
            setVal(x);
            console.log("Miesiaasdf" + x);
        }

         

    return <fieldset>
          
            <select   value={val} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={props.className + "   " + cnX} >
                {
                    gr.map( (item, ix) => {
                        return <option value={item.v} key={item.v}>{item.title}</option>
                    } )
                }
              
            </select>

             {imgx}
             <br/>
             <span className="form_err">{err + " "} &nbsp; </span>             
             {dlg}
           </fieldset>
}


export default InputComboDzien;

